import * as LucideIcons from 'lucide-react';
import { 
  PlugConnectedIcon, 
  DrumIcon, 
  SoupIcon, 
  CoffeeIcon, 
  StarIcon, 
  TruckElectricIcon, 
  PassportIcon, 
  PlayerIcon,
  HeartIcon,
  CameraIcon,
  WifiIcon,
  BatteryIcon,
  FlameIcon,
  TrashIcon,
  UsersIcon,
  CartIcon,
  BellIcon,
  MagnifierIcon,
  MessageCircleIcon,
  WalletIcon,
  CreditCardIcon,
  CurrencyDollarIcon,
  AccessibilityIcon,
  BrandBagsFmIcon,
  BananaIcon,
  CameraOffIcon,
  InfoCircleIcon,
  UsersGroupIcon,
  UserPlusIcon,
  UserCheckIcon,
  MapPinIcon,
  LogoutIcon,
  LetterPIcon,
  ShieldCheckIcon,
  Cloud1Icon
} from './AnimatedIcons';

export interface PointIconProps {
  name: string;
  size?: number;
  className?: string;
  color?: string;
}

export function PointIcon({ name, size = 24, className = '', color = 'currentColor' }: PointIconProps) {
  // Mapping of animated icons
  const AnimatedMap: Record<string, any> = {
    'PlugConnected': PlugConnectedIcon,
    'Drum': DrumIcon,
    'Soup': SoupIcon,
    'Coffee': CoffeeIcon,
    'Star': StarIcon,
    'TruckElectric': TruckElectricIcon,
    'Passport': PassportIcon,
    'Player': PlayerIcon,
    'Heart': HeartIcon,
    'Camera': CameraIcon,
    'Wifi': WifiIcon,
    'Battery': BatteryIcon,
    'Flame': FlameIcon,
    'Trash': TrashIcon,
    'Users': UsersIcon,
    'Cart': CartIcon,
    'Bell': BellIcon,
    'Magnifier': MagnifierIcon,
    'MessageCircle': MessageCircleIcon,
    'Wallet': WalletIcon,
    'CreditCard': CreditCardIcon,
    'CurrencyDollar': CurrencyDollarIcon,
    'Accessibility': AccessibilityIcon,
    'BrandBagsFm': BrandBagsFmIcon,
    'Banana': BananaIcon,
    'CameraOff': CameraOffIcon,
    'InfoCircle': InfoCircleIcon,
    'UsersGroup': UsersGroupIcon,
    'UserPlus': UserPlusIcon,
    'UserCheck': UserCheckIcon,
    'MapPinIcon': MapPinIcon,
    'Logout': LogoutIcon,
    'LetterP': LetterPIcon,
    'ShieldCheck': ShieldCheckIcon,
    'Cloud1': Cloud1Icon,
    'Cloud1Icon': Cloud1Icon
  };

  const AnimatedComponent = AnimatedMap[name];
  if (AnimatedComponent) {
    return <AnimatedComponent size={size} className={className} color={color} loop={true} />;
  }

  // Fallback to standard Lucide icons
  const Icon = (LucideIcons as any)[name] || LucideIcons.MapPin;
  return <Icon size={size} className={className} color={color} />;
}
